// The benchmark endpoint returns every configured benchmark in one payload, so each
// region's table filters the response down to its own symbols.
export const domesticBenchmarkSymbols = ['BSE500', 'NIFTY 50', 'NIFTY BANK', 'BSE100', 'BSE MID 150', 'SML250'];
export const globalBenchmarkSymbols = ['SPX'];

// Display order for benchmark rows. Symbols missing from this list sort to the top
// (indexOf returns -1), so every benchmark the backend can return must be listed.
export const benchmarkOrder = [...domesticBenchmarkSymbols, ...globalBenchmarkSymbols];
